const PAYMENT_SERVER_URL = process.env.NODE_ENV === 'production'
  ? 'https://workshop-payments.herokuapp.com/sus'
  : 'https://workshop-payments.herokuapp.com/sus';

  // ? 'http://localhost:8080/'
  // : 'http://localhost:8080/';

export default PAYMENT_SERVER_URL;